import { type ReportedTimings } from '@atlassian/ufo-experimental/types';

export { SUBSCRIBE_ALL, UFOGlobalEventStreamEventType } from '@atlassian/ufo-experimental/types';

export type {
	CustomData,
	UFOGlobalEventStreamExperiencePayload,
	UFOGlobalEventStreamEvent,
	UFOGlobalEventStreamSubscribe,
	SubscribeCallback,
	UFOGlobalEventStreamUnsubscribe,
	ExperienceMetrics,
	ExperienceData,
	PageLoadExperienceData,
} from '@atlassian/ufo-experimental/types';

export enum TenantType {
	RealUser = 'real-user',
	Synthetic = 'synthetic',
}

export type AppConfig = {
	framework?: { name: string; version: string };
	version: { ssr?: string; web: string };
};

type MappedPerformanceMark = { name: string; type: 'start' | 'end' };

type MapPerformanceMark = (mark: string) => MappedPerformanceMark | null;

export type BundleEvalTimingsConfig = {
	additionalTimings?: (startTime: number) => ReportedTimings;
	mapPerformanceMark: MapPerformanceMark;
};

export type ResourceEntry = {
	duration: number;
	fetchStart: number;
	initiatorType: string;
	name: string;
	responseStart: number;
	startTime: number;
	// Safari returns undefined https://developer.mozilla.org/en-US/docs/Web/API/PerformanceResourceTiming/transferSize
	transferSize: number | void;
	workerStart: number;
};

export type ResourceTimingsConfig = {
	hasTimingHeaders?: (url: string) => boolean;
	mapResources: (url: string) => string | null;
	sanitiseEndpoints: (url: string) => string | null;
	xhrFilter?: (url: string) => boolean;
};
